
export default {
  getShopInfo: (shopId) => {
    return fetch(
      `${process.env.VUE_APP_APIHOST}/apis/shops/${shopId}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  findShops: (portal, latitude, longitude, placeId, category) => {

    return fetch(`${process.env.VUE_APP_APIHOST}/apis/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        portal: portal,
        latitude: latitude,
        longitude: longitude,
        placeId: placeId,
        category: category
      }),
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getQrInfo: (qrId) => {
    let url = `${process.env.VUE_APP_APIHOST}/apis/order-sessions/${qrId}`;
    return fetch(
      url
      // `${process.env.VUE_APP_APIHOST}/apis/portals/${portalId}/shops?category=${category}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())

  },
  getTopProducts: (shopId) => {
    let url = `${process.env.VUE_APP_APIHOST}/apis/shops/${shopId}/top-products`;
    return fetch(
      url
      // `${process.env.VUE_APP_APIHOST}/apis/portals/${portalId}/shops?category=${category}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())

  },
  getPortalInfo: (portalId) => {
    let url = `${process.env.VUE_APP_APIHOST}/apis/portals/${portalId}`;
    return fetch(
      url
      // `${process.env.VUE_APP_APIHOST}/apis/portals/${portalId}/shops?category=${category}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getPortalShops: (portalId, category, options) => {
    category = category || 'catering';

    let query = {
      category: category
    };
    for (let attr in options)
      query[attr] = options.attr;

    var queryString = Object.keys(query).map(function (key) {
      return key + '=' + query[key]
    }).join('&');

    let url = `${process.env.VUE_APP_APIHOST}/apis/portals/${portalId}/shops?${queryString}`;

    return fetch(
      url
      // `${process.env.VUE_APP_APIHOST}/apis/portals/${portalId}/shops?category=${category}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getBeSystemVersion: (portalId) => {
    return fetch(
      `${process.env.VUE_APP_APIHOST}/apis/version`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  // -------
  // portal related apis
  // -------
  getPortalBanners: (portalId) => {
    return fetch(
      `${process.env.VUE_APP_APIHOST}/apis/banners?p=${portalId}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getPortalSettings: (portalId) => {
    return fetch(
      `${process.env.VUE_APP_APIHOST}/apis/settings?p=${portalId}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getPortalCsContent: (portalId) => {
    return fetch(
      `${process.env.VUE_APP_APIHOST}/apis/cs-page-content?p=${portalId}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  // -------
  // place related functions
  // -------
  getPlaceAutoComplete: (text, sessionToken) => {
    return fetch(
      `${process.env.VUE_APP_APIHOST}/apis/location?s=${encodeURIComponent(
        text
      )}&sessiontoken=${sessionToken}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getAddressByGps: (lat, lng) => {

    return fetch(
      `${process.env.VUE_APP_APIHOST}/apis/address?lat=${lat}&lng=${lng}`
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  // -------
  // orders related functions
  // -------
  getPortalOrders: (userId, portalId, shopId, statusFilter) => {
    let url = `${process.env.VUE_APP_APIHOST}/apis/users/${userId}/orders?p=${portalId}`;
    if (shopId)
      url += `&shop_id=${shopId}`
    if (statusFilter)
      url += `&status=${statusFilter}`;

    return fetch(
      url
    )
      .then(res => res.json());
  },
  getPortalOrdersByUuid: (uuid, portalId, shopId, statusFilter) => {
    let url = `${process.env.VUE_APP_APIHOST}/apis/ssousers/${uuid}/orders?p=${portalId}`;
    if (shopId)
      url += `&shop_id=${shopId}`
    if (statusFilter)
      url += `&status=${statusFilter}`;

    return fetch(
      url
    )
      .then(res => res.json());
  },
  getOrderDetail: (userId, orderId) => {

    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/orders/${orderId}`)
      .then(res => res.json());
  },
  getOrderDetailByUuid: (uuid, orderId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${uuid}/orders/${orderId}`)
      .then(res => res.json());
  },
  getOrderDetailByToken: (token, orderId) => {

    return fetch(`${process.env.VUE_APP_APIHOST}/apis/orders/${orderId}?token=${token}`)
      .then(res => res.json());
  },
  // getOrderStatus: () => {
  //   fetch(`https://app-dev.quickclick.cc/admin/apis/businesses/${businessId}/orders/${orderId}/logs`)
  // },
  // -------
  // user related functions
  // -------
  getUserNotifyLogs: (userId, portalId, shopId) => {
    let url = `${process.env.VUE_APP_APIHOST}/apis/users/${userId}/notify-logs?p=${portalId}`;
    if (shopId)
      url += `&shop_id=${shopId}`

    return fetch(
      url
    )
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getUserData: (userId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/data`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getSsoUserData: (uuid) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${uuid}/data`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  putUserData: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/data`, {

      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  putSsoUserData: (uuid, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${uuid}/data`, {

      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getUserProfile: (userId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getSsoUserProfile: (uuid) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${uuid}`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  postUserProfile: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  postSsoUserProfile: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getUserAddresses: (userId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/addresses`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getSsoUserAddresses: (userId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/addresses`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getAddressById: (userId, addressId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/addresses/${addressId}`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getSsoUserAddressById: (userId, addressId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/addresses/${addressId}`)
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  postUserAddresses: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/addresses`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  postSsoUserAddresses: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/addresses`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  putUserAddress: (userId, addressId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/addresses/${addressId}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  putSsoUserAddress: (userId, addressId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/addresses/${addressId}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  setUserDefaultAddress: (userId, addressId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/addresses/${addressId}/default`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  setSsoUserDefaultAddress: (userId, addressId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/addresses/${addressId}/default`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  delUserAddress: (userId, addressId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/addresses/${addressId}`, {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  delSsoUserAddress: (userId, addressId) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/addresses/${addressId}`, {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  sendUserPhoneVerifySms: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/phone/sms-verify`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  sendSsoUserPhoneVerifySms: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/phone/sms-verify`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  checkUserPhone: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/users/${userId}/phone/sms-check`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  checkSsoUserPhone: (userId, body) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/ssousers/${userId}/phone/sms-check`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  checkQCMoney: (phone) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/qcmoney?phone=${phone}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getQCMoneyTransactions: (phone) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/qcmoney/transactions?phone=${phone}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  getQCMoneyExchangesByShopId: (shopId, phone) => {
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/accounts/${shopId}/qcmoney-exchange?phone=${phone}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  },
  changePointsToQCMoney: (shopId, data) => {
    // data.phone, data.vendor, data.vendorPoints
    return fetch(`${process.env.VUE_APP_APIHOST}/apis/accounts/${shopId}/qcmoney-exchange/qcmoney`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
      .then(function (response) {                      // first then()
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response;
      })
      .then(res => res.json())
  }
};
